import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { UserInfoRequestModel } from "src/app/models/request/userInfo-request";
import { ResultOfT } from "src/app/models/response/result";
import { UserInfoResponseModel } from "src/app/models/response/userInfo-response";
import { UserService } from "src/app/services/user.service";
import { WebStorageService } from "src/app/services/web-storage.service";
import { BaseComponent } from "src/app/shared/base.component";
import { Constants } from "src/app/shared/constants";
import { CustomValidator } from "src/app/shared/custom-validator";
import { UserRole } from "src/app/shared/enum";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-manage-inception-admin-users',
    templateUrl: './manage-inception-admin-users.component.html',
    styleUrls: ['./manage-inception-admin-users.component.sass']
})
export class ManageInceptionAdminUsersComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
    private unsubscriber = new Subject<boolean>();
    private progress = new Subject<boolean>();

    @Output() close: EventEmitter<any> = new EventEmitter();

    @Input() refresh: boolean = false;
    @Input() id: number;

    displayMessage: boolean = false;
    message: string = '';
    messageClass: boolean;


    userId: number;
    role: string;
    isEditMode: boolean;
    isEditPermission: boolean;
    userInfoId: number;
    isActive: boolean = true;
    modifiedBy: number;

    userInfoResponseModel: UserInfoResponseModel;
    formFields = {
        FirstName: 'FirstName',
        LastName: 'LastName',
        Email: 'Email',
    };

    validationMessages = {
        FirstName: {
            required: 'First name is required',
            validCharacters: 'Enter valid first name'
        },
        LastName: {
            required: 'Last name is required',
            validCharacters: 'Enter valid last name'
        },
        Email: {
            required: 'Email is required',
            email: 'Enter valid email adderss'
        },
    };
    removeImage: any;
    ManageUserPopup: boolean;

    constructor(private formBuilder: FormBuilder, private userService: UserService, private webStorageService: WebStorageService) {
        super();
        let currentUser = this.webStorageService.getCurrentUserToken();
        if (currentUser) {
            this.modifiedBy = currentUser.userId;
        }
    }
    ngOnDestroy(): void {
        if (this.unsubscriber) {
            this.unsubscriber.next();
            this.unsubscriber.complete();
        }
        if (this.progress) {
            this.progress.complete();
        }
    }

    ngOnInit(): void {
        this.buildForm();
// debugger;
        if (this.id > 0) {
            this.isEditMode = true;
            this.userId = this.id;
            this.getUserInfo();
        } else {
            this.isEditMode = false;
            this.userId = this.id;
        }
    }

    
  ngOnChanges() {
    // debugger
    if (this.refresh) {
      if (this.id > 0) {
        this.userId = this.id;
        this.isEditMode = true;
        this.getUserInfo();
      } else {
        this.isEditMode = false;
        this.resetUserForm();
      }

    }
  }

    closePopup() {
        this.resetUserForm();
        this.close.emit();
    }

    
  closeMessagePopup() {
    this.displayMessage = false;
  }

    onSubmit() {
        if (this.form.invalid) {
            this.markFormAsTouched();
            return;
        }

        const userInfoRequestModel = this.getValuesFromForm();
        this.loading = true;
        const userManage = this.isEditMode ? this.userService.updateUser(userInfoRequestModel)
            : this.userService.saveUser(userInfoRequestModel);

        userManage
            .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
            .subscribe((result: ResultOfT<any>) => {
                this.processResult<any>(result, () => {
                    if (result.IsSuccess) {
                        var message = this.isEditMode ? 'User updated successfully' : 'User added successfully';
                        this.loading = false;
                        this.timeoutFunct(message, true);
                        setTimeout(() => {
                            this.closePopup();
                            this.close.emit(true);
                        }, environment.messageLifeSpan);
                    } else {
                        this.loading = false;
                        this.timeoutFunct(result.Message, false);
                    }
                });
            }, (httpResponseError) => {
                this.loading = false;
                this.timeoutFunct(httpResponseError.message, false);
            });

    }


    resetUserForm() {
        this.form.reset();
        this.isEditMode = false;
        this.id = 0;
        this.userInfoResponseModel = null;
        this.ManageUserPopup = false;
        this.isActive = true;
    }

    getValuesFromForm() {
        const form = this.form;

        const userInfoReuestModel = new UserInfoRequestModel();

        userInfoReuestModel.userId = this.isEditMode ? this.userInfoId : 0;
        userInfoReuestModel.firstName = form.get(this.formFields.FirstName).value;
        userInfoReuestModel.lastName = form.get(this.formFields.LastName).value;
        userInfoReuestModel.email = form.get(this.formFields.Email).value;
        userInfoReuestModel.isActive = this.isActive;
        //   userInfoReuestModel.CompanyId = this.companyId;
        userInfoReuestModel.Role = UserRole.enumAdmin;
        userInfoReuestModel.ModifiedBy = this.modifiedBy;

        return userInfoReuestModel;

    }

    setValuesToForm() {
        this.form.reset();
        if (!this.userInfoResponseModel) {
            return;
        }

        const form = this.form;
        this.userInfoId = this.userInfoResponseModel.UserId;
        // this.companyId = this.userInfoResponseModel.CompanyId;
        form.get(this.formFields.FirstName).setValue(this.userInfoResponseModel.FirstName);
        form.get(this.formFields.LastName).setValue(this.userInfoResponseModel.LastName);
        form.get(this.formFields.Email).setValue(this.userInfoResponseModel.Email);
        this.isActive = this.userInfoResponseModel.IsActive;
    }
    private buildForm() {

        const formGroup = this.formBuilder.group({});

        formGroup.addControl(this.formFields.FirstName, this.formBuilder.control('',
            { validators: [Validators.required, CustomValidator.onlyCharacters], updateOn: Constants.formControlUpdateStrategy.change }));
        formGroup.addControl(this.formFields.LastName, this.formBuilder.control('',
            { validators: [Validators.required, CustomValidator.onlyCharacters], updateOn: Constants.formControlUpdateStrategy.change }));
        formGroup.addControl(this.formFields.Email, this.formBuilder.control('',
            { validators: [Validators.required, CustomValidator.email], updateOn: Constants.formControlUpdateStrategy.change }));

        this.form = formGroup;
    }

    private getUserInfo(): void {
        if (!this.userId) {
            return;
        }

        this.isEditMode = true;
        this.loading = true;

        this.userService.getUsers(this.userId)
            .pipe(takeUntil(this.unsubscriber), finalize(() => this.progress.next(false)))
            .subscribe((result: ResultOfT<UserInfoResponseModel>) => {
                this.processResult<UserInfoResponseModel>(result, () => {
                    if (result.IsSuccess) {
                        this.userInfoResponseModel = result.ResponseModel;
                        this.loading = false;
                        this.setValuesToForm();
                    } else {
                        this.loading = false;
                        this.timeoutFunct(result.Message, false);
                    }
                });
            }, (httpResponseError) => {
                this.loading = false;
                this.timeoutFunct(httpResponseError.message, false);
            });
    }

    timeoutFunct(msg, isSuccess: boolean) {
        this.displayMessage = true;
        this.messageClass = isSuccess;
        this.message = msg;
        setTimeout(() => {
            this.message = '';
            this.displayMessage = false;
        }, environment.messageLifeSpan);
    }
}